import { Component, OnInit } from '@angular/core';
import { FormBuilder, AbstractControl, ValidatorFn, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PrivateSectorService } from 'src/app/services/private-sector.service';

@Component({
  selector: 'app-private-sector-edit',
  templateUrl: './private-sector-edit.component.html',
  styleUrls: ['./private-sector-edit.component.css']
})
export class PrivateSectorEditComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private service: PrivateSectorService,
    private formBuilder: FormBuilder,
    private router: Router
  ) { }

  item$
  itemForm: FormGroup;
  id: string;
  subcat: string;
  isAddMode: boolean;
  loading = false;
  submitted = false;

  ngOnInit() {
    this.isAddMode = false;
    this.id = this.route.snapshot.paramMap.get('id');
    this.subcat = this.route.snapshot.paramMap.get('sc');
    this.isAddMode = !this.id

    this.itemForm = this.formBuilder.group({
      name: ['',Validators.required],
      number: ['',Validators.required],
      url: [''],
      image: [''],
      file: ['', this.fileExtensionValidator('jpg')]
    });

    this.item$ = this.service.getItem(this.subcat, this.id).subscribe(item => { 
      this.itemForm.patchValue(item);
      this.item$ = item
    });

  }

  private fileExtensionValidator(extension: string): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      // File must be jpg or null
      const valid = control.value.split(".").pop() === extension || control.value === ""
      return !valid ? {forbiddenExtension: {value: control.value}} : null;
    };
  }

  private createItem() {

    console.log(this.itemForm.value);
    this.loading = false;
    // this.userService.create(this.form.value)
    //   .pipe(first())
    //   .subscribe({
    //     next: () => {
    //       this.alertService.success('User added', { keepAfterRouteChange: true });
    //       this.router.navigate(['../'], { relativeTo: this.route });
    //     },
    //     error: error => {
    //       this.alertService.error(error);
    //       this.loading = false;
    //     }
    //   });
  }

  // convenience getter for easy access to form fields
  get f() { return this.itemForm.controls; }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    console.log(this.itemForm.invalid)
    if (this.itemForm.invalid) {
      return;
    }

    this.loading = true;
    // TODO : File upload
    var number = this.itemForm.value['number'];
    this.service.uploadFile(this.itemForm.value["file"], this.subcat, number);
    if (this.isAddMode) {
      this.createItem();
    } else {
      this.updateItem();
    }
  }

  private updateItem() {
    console.log(this.itemForm.value);
    this.loading = false; // TODO: Remove this
    // this.service.updateItem(this.subcat, this.id, this.itemForm.value).then(
    //     () => {
    //       console.log("success");
    //       this.loading = false;
    //       this.router.navigate(['../../../sc/' + this.subcat], { relativeTo: this.route });
    //     },
    //     error => {
    //       this.loading = false;
    //     }
    // );
  }
}
